import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import { Chart } from "react-google-charts";
import "./Dashboardtrails.css";
import HeaderNavigation from "../../../../Componants/Common/header Navigation/HeaderNavigation";
import DynamicTabs from "../../../../components/DynamicTabs";
import { Box, Modal, TextField } from "@mui/material";
import { getSuperAdminTrailsDashboard,getOrganizations,extendTrialApi} from "../../../../API Service/apiService";
import Paginate from "../../../../Componants/Common/Paginate";
import Loader from "../../../../Componants/Loader/Loader";
import activeIcon from "../../../../Assests/activeIcon.svg";
import inactiveIcon from "../../../../Assests/inactiveIcon.svg";
import {toast,Toaster} from "react-hot-toast";
import { formatDate } from "../../../../utils/dateFormatter";


const Dashboardtrails = () => {
  const [trails, setTrails] = useState([]);
  const [organizations, setOrganizations] = useState([]);
  // const [extendTrial, setExtendTrial] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [dataSize, setDataSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [trialDays, setTrialDays] = useState("");
  const [organizationId, setOrganizationId] = useState("");
  // const [extendTrialStatus, setExtendTrialStatus] = useState(false);

  useEffect(()=>{
    fetchOrganizations();
  },[page,dataSize]);

  useEffect(()=>{
    fetchTrails();
  },[]);

  const fetchTrails=async()=>{
    setIsLoading(true);
    try{
      const response=await getSuperAdminTrailsDashboard();
      setTrails(response);
      // setTotalRecords(response.data.pagination.totalRecords);
    }catch(error){
      console.error("Error fetching trails:", error);
    }finally{
      setIsLoading(false);
    }
  };

  const fetchOrganizations=async()=>{
    setIsLoading(true);
    try{
      let body={
        subscriptionType: "trial",
        page,
        dataSize
      }
      const response=await getOrganizations(body);
      setOrganizations(response.data.organizations);
      setTotalRecords(response.data.pagination.totalRecords);
    }catch(error){
      console.error("Error fetching organizations:", error);
    }finally{
      setIsLoading(false);
    }
  }

  const handleExtendTrial = async () => {
    try {
      let body={
        organizationId,
        trialDays
      }
      const response = await extendTrialApi(body);
      console.log(response);
      if(response.status==="success"){
        fetchOrganizations();
        toast.success(response.message || "extending trial successfully");
      }
      // setExtendTrialStatus(true);
      handleCloseModal();
    } catch(error) {
      handleCloseModal();
      toast.error(error.response.data.message || error.response.data.error || "Error extending trial");
      console.error("Error extending trial:", error);
    }
  };

  const handlePageChange=(newPage)=>{
    setPage(newPage);
  };

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () =>{
    setOpenModal(false);
    setTrialDays("");
  }
    
  return (
    <>
    {isLoading && <Loader/>}
    <Toaster/>
      <HeaderNavigation value={"Trials"} />
      <DynamicTabs />
      <div className="container-Dashboardtrails">
        <div className="Dashboard-Dashboardtrails">
          <div className="databox-Dashboardtrails">
            <div className="boxone-Dashboardtrails">
              <div className="firsttext--Dashboardtrails">Total Trials</div>
              <div className="firsttext--Dashboardtrails">
                {trails.totalTrials}
              </div>
            </div>
            <div className="boxone-Dashboardtrails">
              {" "}
              <div className="firsttext--Dashboardtrails">Active trials</div>
              <div className="firsttext--Dashboardtrails">
                {trails.activeTrials}
              </div>
            </div>
            <div className="boxone-Dashboardtrails">
              {" "}
              <div className="firsttext--Dashboardtrails">Stopped Trials</div>
              <div className="firsttext--Dashboardtrails">
                {trails.stoppedTrials}
              </div>
            </div>
            <div className="boxone-Dashboardtrails">
              {" "}
              <div className="firsttext--Dashboardtrails">Ending In 7 Days</div>
              <div className="firsttext--Dashboardtrails">
                {trails.endingThisWeek}
              </div>
            </div>
          </div>

          {/* <div className="chart-Dashboardtrails">
            <div>
              {" "}
              <Chart
                width={"100%"}
                height={"300px"}
                chartType="LineChart"
                loader={<div>Loading Chart</div>}
                data={[
                  ["X", "Dogs", "Cats"],
                  [0, 0, 0],
                  [1, 10, 5],
                  [2, 23, 15],
                  [3, 17, 9],
                  [4, 18, 10],
                  [5, 9, 5],
                  // Add your chart data here
                ]}
                options={{
                  hAxis: {
                    title: "Date",
                  },
                  vAxis: {
                    title: "Subscriptions",
                  },
                  colors: ["#a52714", "#097138"],
                }}
                rootProps={{ "data-testid": "1" }}
              />
            </div>

            <div></div>
          </div> */}
          <div className="table-Dashboardtrails">
            <table>
              <thead>
                <tr>
                  <th style={{ width: '5%' }}>Sr. No.</th>
                  <th style={{ width: '15%' }}>Company Name</th>
                  <th style={{ width: '12%' }}>Client Name</th>
                  <th style={{ width: '10%' }}>Total Licenses</th>
                  <th style={{ width: '10%' }}>left Licenses</th>
                  <th style={{ width: '12%' }}>Trial Start Date</th>
                  <th style={{ width: '12%' }}>Trial End Date</th>
                  <th style={{ width: '8%' }}>Status</th>
                  <th style={{ width: '16%' }}>Extand Trial</th>
                </tr>
              </thead>
              <tbody>
                {organizations.map((organization,index)=>(
                <tr key={index}>
                  <td style={{ width: '5%' }}>{(index+1)+(page-1)*dataSize}</td>
                  <td style={{ width: '15%' }}>{organization.companyName}</td>
                  <td style={{ width: '12%' }}>{organization.clientName}</td>
                  <td style={{ width: '10%' }}>{organization.licenseKeys[0].noOfLicense}</td>
                  <td style={{ width: '10%' }}>{organization.licenseKeys[0].leftLicence}</td>
                  <td style={{ width: '12%' }}>{formatDate(organization.trialStartDate)}</td>
                  <td style={{ width: '12%' }}>{formatDate(organization.trialEndDate)}</td>
                  <td style={{ width: '8%' }}>
                    {organization.trialStatus===true ? <img src={activeIcon} alt="active" /> : <img src={inactiveIcon} alt="inactive" />}

                  </td>
                  <td style={{ width: '16%' }}>
                    {" "}
                    <span className="buttons-Dashboardtrails-span">
                      <Button
                        className="action-button"
                        size="small"
                        // disabled={extendTrialStatus}
                        onClick={()=>{
                          setOrganizationId(organization._id);
                          handleOpenModal();
                        }}

                        variant="contained"
                        style={{ backgroundColor: "#32499F", color: "white" }}
                        // onClick={handleOpenModal}
                      >
                        Extend Trial
                      </Button>
                    </span>
                  </td>
                </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="pagination-container">
          <Paginate
            page={page}
            totalRecords={totalRecords}
            onPageChange={handlePageChange}
            dataSize={dataSize}
            // onDataSizeChange={handleDataSizeChange}
          />
        </div>
      </div>
      <Modal open={openModal} onClose={handleCloseModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 3,
            borderRadius: "10px",
          }}
        >
          <h3>Extend Trial</h3>
          <TextField
            fullWidth
            label="Enter Days"
            variant="outlined"
            type="number"
            value={trialDays}
            onChange={(e) => setTrialDays(e.target.value)}
            sx={{ mt: 2 }}
          />
          <Button
            fullWidth
            variant="contained"
            sx={{ mt: 2, bgcolor: "#32499F", color: "white" }}
            onClick={handleExtendTrial}
          >
            Confirm
          </Button>
        </Box>
      </Modal>
    </>
  );
};

export default Dashboardtrails;
